import React from 'react'
import {
  FieldErrors,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetError,
  UseFormSetValue,
  UseFormTrigger,
} from 'react-hook-form'
import { Box } from '@node-space/ui-components'
import { useBankDetailsForm } from 'pages/Contacts/hooks/useBankDetailsForm'
import { ContactFiatInstrumentFormData } from 'pages/Contacts/schemas/contactFiatInstrumentSchema'
import { FormFieldLabels } from 'pages/Contacts/types/fiatInstruments'
import { BeneficiaryDetails, BeneficiaryDetailsCurrency } from 'types/beneficiaries'
import { EURBankDetails } from './EURBankDetails'
import { GBPBankDetails } from './GBPBankDetails'
import { USDBankDetails } from './USDBankDetails'

export type BankDetailsProps = {
  formValues: ContactFiatInstrumentFormData
  errors: FieldErrors<ContactFiatInstrumentFormData>
  isBusinessAccount: boolean
  formFieldLabels: FormFieldLabels
  clearErrors: UseFormClearErrors<ContactFiatInstrumentFormData>
  register: UseFormRegister<ContactFiatInstrumentFormData>
  setValue: UseFormSetValue<ContactFiatInstrumentFormData>
  trigger: UseFormTrigger<ContactFiatInstrumentFormData>
  setError: UseFormSetError<ContactFiatInstrumentFormData>
  contactBeneficiary?: BeneficiaryDetails
}

export const BankDetails = ({
  formFieldLabels,
  formValues,
  errors,
  clearErrors,
  register,
  setValue,
  trigger,
  setError,
  contactBeneficiary,
}: BankDetailsProps) => {
  const bankDetailsForm = useBankDetailsForm({
    formValues,
    errors,
    clearErrors,
    setValue,
    trigger,
    setError,
    contactBeneficiary,
  })

  const currency = formValues?.currency

  return (
    <Box width="full" paddingT={12}>

      {
        currency === BeneficiaryDetailsCurrency.USD && (
          <USDBankDetails
            formValues={formValues}
            errors={errors}
            formFieldLabels={formFieldLabels}
            clearErrors={clearErrors}
            register={register}
            setError={setError}
            setValue={setValue}
            bankDetailsForm={bankDetailsForm}
          />
        )
      }
      {
        currency === BeneficiaryDetailsCurrency.EUR && (
          <EURBankDetails
            formValues={formValues}
            errors={errors}
            formFieldLabels={formFieldLabels}
            clearErrors={clearErrors}
            register={register}
            setError={setError}

            setValue={setValue}
            bankDetailsForm={bankDetailsForm}
          />
        )
      }

      {
        currency === BeneficiaryDetailsCurrency.GBP && (
          <GBPBankDetails
            formValues={formValues}
            errors={errors}
            formFieldLabels={formFieldLabels}
            clearErrors={clearErrors}
            register={register}
            setError={setError}
            setValue={setValue}
            bankDetailsForm={bankDetailsForm}
          />
        )
      }
    </Box>
  )
}
